<template>
    <input :type="type" :value="value" :placeholder="placeholder" :disabled="disabled" :required="required"
        @input="$emit('input', $event.target.value)"
        class="tw:w-full tw:px-4 tw:py-2 tw:bg-slate-50 tw:border tw:border-slate-200 tw:rounded-xl tw:text-sm tw:text-slate-800 focus:tw:bg-white focus:tw:ring-2 focus:tw:ring-blue-500/20 focus:tw:border-blue-600 tw:transition-all">
</template>

<script>
export default {
    name: 'BaseInput',
    props: {
        // En Vue 2, v-model pasa automáticamente una prop llamada "value"
        value: {
            type: [String, Number],
            default: ''
        },
        type: {
            type: String,
            default: 'text' // Puede ser 'email', 'password', 'date', etc.
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    }
}
</script>